
<script>
import { Bar } from "vue-chartjs";

export default {
  extends: Bar,
  props:{
    chartData:{type:Array},
    labels:{type:Array},

  },
  mounted() {
    this.renderChart(
      {
        labels: this.labels,
        datasets: [
          {
            label: "Number of Worker",
            backgroundColor: "#32c040",
            data: this.chartData,
            // borderWidth:10,
            barPercentage: 0.5,
            // barThickness: 6,
            // maxBarThickness: 8,
            // minBarLength: 2,
          },
        ],
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        scales: {
          yAxes: [
            {
              ticks: {
                min: 0,
                // max: 300,
                stepSize: 2,
                //   reverse: false,
                //   beginAtZero: true,
                callback: function (value, index, values) {
                  return value + " People";
                },
              },
            },
          ],
        },
        plugins: {
            legend: {
                display: true,
                labels: {
                    color: 'rgb(255, 99, 132)'
                },
                position: 'right',
                align: 'start'
            }
        },
      }
    );
  },
  // computed: {
  //   chartData: function () {
  //     console.log('chartData');
  //     // return this.data;
  //   },
  // },
};
</script>

<style>
</style>